module.exports = __webpack_public_path__ + "img/temp-forecast-img1.4dc472f3.jpg";